
export const apiErrorHandler = (apiError, isForm, errorTranslationsMap, returnStrings = false, callback) => {
  const defaultErrorMessage = {
    id: 'SummaryAndPrescriptions.Snackbar.Error',
    defaultMessage: '** Something went wrong. Please try again, and if the issue persists contact your administrator.',
  };

  if (!apiError || !apiError.graphQLErrors || !apiError.graphQLErrors.length || apiError.graphQLErrors[0] === 'Internal Server Error') {
    return isForm
      ? { _error: defaultErrorMessage }
      : returnStrings
        ? defaultErrorMessage.defaultMessage
        : defaultErrorMessage;
  }

  let errorFields = [];

  apiError.graphQLErrors.forEach(({ extensions }) => {
    if (!extensions) return;
    if (extensions.code) errorFields.push(extensions.code);
  });

  if (isForm) {
    const formErrors = {};
    apiError.graphQLErrors.forEach(({ extensions }) => {
      if (!extensions) return;
      const { code: errorCode, fields } = extensions;
      if (errorCode && errorTranslationsMap[errorCode]) {
        if (fields) {
          fields.forEach(item => {
            formErrors[item] = errorCode;
          });
        } else if (errorTranslationsMap[errorCode].fields) {
          errorTranslationsMap[errorCode].fields.forEach(field => {
            formErrors[field] = errorCode;
          });
        } else {
          formErrors[errorTranslationsMap[errorCode].field] = errorCode;
        }
      }
    });
    if (!Object.keys(formErrors).length) formErrors['_error'] = defaultErrorMessage;
    errorFields = formErrors;
  }

  if (errorTranslationsMap && errorFields.length) {
    const formErrors = [];
    errorFields.forEach(item => {
      if (errorTranslationsMap[item]) {
        formErrors.push(!returnStrings ? errorTranslationsMap[item] : errorTranslationsMap[item].defaultMessage);
      }
    });
    errorFields = formErrors;
  }

  if (callback) callback(errorFields);

  if (errorFields['_error']) {
    errorFields['_error'] = errorTranslationsMap[errorFields['_error']] || defaultErrorMessage;
  }

  Object.entries(errorFields).forEach(([key, value]) => {
    const nested = key.split('.');
    if (nested.length) {
      let obj = errorFields;
      nested.forEach((item, index) => {
        obj[item] = index < nested.length - 1 ? {} : value;
        obj = obj[item];
      });
    }
  });

  return errorFields;
};
